import { useState } from "react";

const SEVERITY_STYLES = {
  critical: "border-l-4 border-red-500 bg-red-50",
  warning: "border-l-4 border-yellow-500 bg-yellow-50",
  info: "border-l-4 border-blue-500 bg-blue-50",
};

const SEVERITY_BADGE = {
  critical: "bg-red-100 text-red-800",
  warning: "bg-yellow-100 text-yellow-800",
  info: "bg-blue-100 text-blue-800",
};

const SEVERITY_LABEL = {
  critical: "Crítico",
  warning: "Aviso",
  info: "Info",
};

const STATUS_LABEL = {
  new: "Novo",
  sent: "Enviado",
  ignored: "Ignorado",
  resolved: "Resolvido",
};

export default function OwnerAlertCard({ alert, onIgnore, onResolve }) {
  const [expanded, setExpanded] = useState(false);
  const sev = alert.severity || "info";
  const isActive = !["ignored", "resolved"].includes(alert.status);

  return (
    <div
      className={`rounded-lg p-4 mb-3 shadow-sm ${SEVERITY_STYLES[sev] || SEVERITY_STYLES.info} ${
        !isActive ? "opacity-60" : ""
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <span
              className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                SEVERITY_BADGE[sev] || SEVERITY_BADGE.info
              }`}
            >
              {SEVERITY_LABEL[sev] || sev}
            </span>
            <span className="text-xs text-gray-500">
              {STATUS_LABEL[alert.status] || alert.status}
            </span>
            <span className="text-xs text-gray-400">
              {alert.created_at ? new Date(alert.created_at).toLocaleString("pt-PT") : ""}
            </span>
          </div>
          <p className="font-semibold text-sm text-gray-900">{alert.title}</p>
          <p className="text-sm text-gray-700 mt-0.5">{alert.message}</p>
        </div>
        <button
          onClick={() => setExpanded((e) => !e)}
          className="text-gray-400 hover:text-gray-600 text-xs shrink-0 mt-1"
        >
          {expanded ? "▲" : "▼"}
        </button>
      </div>

      {expanded && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            <span className="font-medium">💡 Recomendação:</span> {alert.recommendation}
          </p>
          <div className="flex gap-2 mt-3 flex-wrap">
            {isActive && (
              <>
                <button
                  onClick={() => onResolve(alert.id)}
                  className="text-xs px-3 py-1.5 rounded bg-green-600 text-white hover:bg-green-700 font-medium"
                >
                  ✓ Resolver
                </button>
                <button
                  onClick={() => onIgnore(alert.id)}
                  className="text-xs px-3 py-1.5 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 font-medium"
                >
                  Ignorar
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
